import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

interface MagazineCompactCardProps {
  title: string;
  author: string;
  readTime: number;
  image: string;
  category: string;
  slug: string;
}

export const MagazineCompactCard = ({
  title,
  author,
  readTime,
  image,
  category,
  slug,
}: MagazineCompactCardProps) => {
  return (
    <Link to={`/article/${slug}`} className="block group">
      <article className="flex gap-4 items-start">
        <div className="relative w-24 h-24 flex-shrink-0 overflow-hidden rounded">
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
            style={{ backgroundImage: `url(${image})` }}
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">
            {category}
          </p>
          <h4 className="font-bold mb-2 line-clamp-2 group-hover:text-primary transition-colors leading-tight">
            {title}
          </h4>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>{author}</span>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {readTime} min
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};
